import Modal from './components/modal_normal';

export default Modal;
